export default __webpack_public_path__ + "static/media/logo.8fd8ab2b.webp";